import apiClient from './apiClient';

class AdminService {
  async getUsers(filters = {}) {
    const params = {};
    if (filters.role) params.role = filters.role;
    if (filters.locked !== undefined) params.locked = filters.locked;
    if (filters.search) params.search = filters.search;

    try {
      return await apiClient.get('/admin/users', { params });
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch users');
    }
  }

  async getUser(userId) {
    try {
      return await apiClient.get(`/admin/users/${userId}`);
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch user');
    }
  }

  async createUser(userData) {
    try {
      const data = await apiClient.post('/admin/users', { user: userData });
      if (!data.success) {
        throw new Error(data.error || data.errors?.join(', ') || 'Failed to create user');
      }
      return data;
    } catch (error) {
      const data = error.response?.data;
      if (data && (!data.success || data.error || data.errors)) {
        throw new Error(data.error || data.errors?.join(', ') || 'Failed to create user');
      }
      throw error;
    }
  }

  async updateUser(userId, userData) {
    try {
      const data = await apiClient.patch(`/admin/users/${userId}`, { user: userData });
      if (!data.success) {
        throw new Error(data.error || data.errors?.join(', ') || 'Failed to update user');
      }
      return data;
    } catch (error) {
      const data = error.response?.data;
      if (data && (!data.success || data.error || data.errors)) {
        throw new Error(data.error || data.errors?.join(', ') || 'Failed to update user');
      }
      throw error;
    }
  }

  async lockUser(userId) {
    try {
      const data = await apiClient.patch(`/admin/users/${userId}/lock`);
      if (!data.success) {
        throw new Error(data.error || 'Failed to lock user');
      }
      return data;
    } catch (error) {
      const data = error.response?.data;
      if (data && !data.success) throw new Error(data.error || 'Failed to lock user');
      throw error;
    }
  }

  async unlockUser(userId) {
    try {
      const data = await apiClient.patch(`/admin/users/${userId}/unlock`);
      if (!data.success) {
        throw new Error(data.error || 'Failed to unlock user');
      }
      return data;
    } catch (error) {
      const data = error.response?.data;
      if (data && !data.success) throw new Error(data.error || 'Failed to unlock user');
      throw error;
    }
  }

  async deleteUser(userId) {
    try {
      const data = await apiClient.delete(`/admin/users/${userId}`);
      if (!data.success) {
        throw new Error(data.error || 'Failed to delete user');
      }
      return data;
    } catch (error) {
      const data = error.response?.data;
      if (data && !data.success) throw new Error(data.error || 'Failed to delete user');
      throw error;
    }
  }
}

export const adminService = new AdminService();